import type { TraderProfile } from '@/types/api/legacy-trader-profile'

import { useCallback, useMemo } from 'react'

import Button, { type ButtonProps } from '@/components/atomic/button'
import Tooltip from '@/components/atomic/tooltip'
import useGetResolvedTraderProfile from '@/trading/hooks/use-get-resolved-trader-profile'

export interface ButtonRequiringTraderProfileProps
  extends Omit<ButtonProps, 'onClick'> {
  onClick: (traderProfile: TraderProfile) => void
}

export const TOOLTIP_TEXT = {
  ORG_DEFAULT_TRADER_PROFILE_MISSING:
    'Your admin needs to setup a default trader profile for your organization before you can take this action.',
}

const ButtonRequiringTraderProfile: React.FC<
  ButtonRequiringTraderProfileProps
> = (props) => {
  const { isOrgDefaultTraderProfileSetup, resolvedTraderProfile } =
    useGetResolvedTraderProfile()

  const handleClick = useCallback(() => {
    if (resolvedTraderProfile) {
      props.onClick(resolvedTraderProfile)
    }
  }, [resolvedTraderProfile, props])

  const button = useMemo(() => {
    return (
      <Button
        {...props}
        disabled={props.disabled || !isOrgDefaultTraderProfileSetup}
        onClick={handleClick}
      />
    )
  }, [handleClick, isOrgDefaultTraderProfileSetup, props])

  const toRender = useMemo(() => {
    if (isOrgDefaultTraderProfileSetup === false) {
      return (
        <Tooltip simpleText={TOOLTIP_TEXT.ORG_DEFAULT_TRADER_PROFILE_MISSING}>
          {button}
        </Tooltip>
      )
    }
    return button
  }, [isOrgDefaultTraderProfileSetup, button])

  return toRender
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default ButtonRequiringTraderProfile
